import type { RouteObject } from 'react-router-dom'

import { Component as PasswordReset } from '@/modules/passwordReset/pages/PasswordReset'
import { Component as PasswordResetVerify } from '@/modules/passwordReset/pages/PasswordResetVerify'

import { PasswordResetRoutePathsEnum } from './passwordResetRouteConfig.types'

export const PASSWORD_RESET_ROUTES: RouteObject[] = [
  {
    element: <PasswordReset />,
    path: PasswordResetRoutePathsEnum.PASSWORD_RESET,
  },
  {
    element: <PasswordResetVerify />,
    path: PasswordResetRoutePathsEnum.PASSWORD_RESET_VERIFY,
  },
]
